import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-headset",
  "use": "icon-headset-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-headset\"><path d=\"M9 .426A8.57 8.57 0 0 0 .428 8.997v8.036c0 .297.24.536.536.536H5.07A1.43 1.43 0 0 0 6.5 16.14v-4.643A1.43 1.43 0 0 0 5.07 10.07H2.035V8.997a6.965 6.965 0 0 1 13.929 0v1.072h-3.036a1.43 1.43 0 0 0-1.428 1.428v4.643c0 .788.64 1.429 1.428 1.429h4.107a.534.534 0 0 0 .536-.536V8.997A8.57 8.57 0 0 0 9 .426zm-4.107 11.25v4.286H2.035v-4.286h2.858zm11.07 4.286h-2.856v-4.286h2.857v4.286z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol